import { keyboardImagesNames, round_enam } from '../../utils/DictionaryManagementUtils';

const isColorValid = (val) => val !== null && val !== undefined && val.length === 7;
export const kbdTheme = ({ theme, services, general }) => {
  const { colors, radius } = theme;

  const themeExport = {
    isItemsRound: !radius.elements_shape_square,
    isMenuItemsRound: services.menu.icon_shape_bars_enam === round_enam,
    colors: {
      primaryFontColor: colors.primary_font_color,
      secondaryFontColor: colors.secondary_font_color,
      tertiaryFontColor: colors.tertiary_icons_color,
      ctaFontColor: colors.cta_font_color,
      primaryCtaColor: colors.primary_cta_color,
      ctaDisabledColor: colors.disabled_cta_color,
      ctaPressedColor: colors.pressed_cta_color,
      borderColor: colors.border_color,
      disabledInputColor: colors.border_light_color,
      lighterBorderColor: colors.border_light_color,
      boxColor: colors.light_elements_color,
      screenBackgroundColor: colors.app_background_color,
      positiveColor: colors.positive_color,
      negativeColor: colors.negative_color,
      linksIconsColor: colors.links_icons_color,
      menuPrimaryColor: colors.menu_primary_color,
      menuSecondaryColor: colors.menu_secondary_color,
      lightElementsColor: colors.light_elements_color,
      menuHeaderBackgroundColor: colors.menu_top_area_color,
      menuBalanceBackgroundColor: colors.menu_balance_color,
    },
    imageAssets: {
      emptyViewImage: keyboardImagesNames.ic_empty_view_state,
    },
  };

  if (general.show_avatar_in_contact_lists) {
    const avatarColors = [];
    if (isColorValid(colors.avatar_color_1)) avatarColors.push(colors.avatar_color_1);
    if (isColorValid(colors.avatar_color_2)) avatarColors.push(colors.avatar_color_2);
    if (isColorValid(colors.avatar_color_3)) avatarColors.push(colors.avatar_color_3);
    if (isColorValid(colors.avatar_color_4)) avatarColors.push(colors.avatar_color_4);

    themeExport.colors.avatarColors = avatarColors;
  }

  return themeExport;
};
export const onboardingTheme = ({ theme, services }) => {
  const { colors, radius } = theme;

  return ({
    isItemsRound: !radius.elements_shape_square,
    isMenuItemsRound: services.menu.icon_shape_bars_enam === round_enam,
    colors: {
      primaryFontColor: colors.primary_font_color,
      secondaryFontColor: colors.secondary_font_color,
      tertiaryFontColor: colors.tertiary_icons_color,
      ctaFontColor: colors.cta_font_color,
      primaryCtaColor: colors.primary_cta_color,
      ctaDisabledColor: colors.disabled_cta_color,
      ctaPressedColor: colors.pressed_cta_color,
      borderColor: colors.border_color,
      disabledInputColor: colors.border_light_color,
      lighterBorderColor: colors.border_light_color,
      boxColor: colors.light_elements_color,
      screenBackgroundColor: colors.app_background_color,
      positiveColor: colors.positive_color,
      negativeColor: colors.negative_color,
      linksIconsColor: colors.links_icons_color,
      menuPrimaryColor: colors.menu_primary_color,
      menuSecondaryColor: colors.menu_secondary_color,
      lightElementsColor: colors.light_elements_color,
      menuHeaderBackgroundColor: colors.menu_top_area_color,
      menuBalanceBackgroundColor: colors.menu_balance_color,
    },
  });
};
